import { Component } from '@angular/core';

import {AlertController, ModalController, NavParams, ToastController, ViewController} from 'ionic-angular';

import { ConferenceData } from '../../../providers/conference-data';
import { MissionsData } from '../../../providers/missions-data';
import { UiData } from '../../../providers/ui-data';
import {UserData} from "../../../providers/user-data";

import { JobSelectForm } from '../../utils/job-select/job-select';
import { Geolocation } from '@ionic-native/geolocation';
import {LocationSelectForm} from "../../utils/location-select/location-select";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {CvAddForm} from "../../account/cv/form/cvform";
import {Observable} from "rxjs/Observable";
import {VideoRecorderForm} from "../../utils/video-recorder/video-recorder";
import {VideoWizardForm} from "../../utils/video-wizard/video-wizard";

@Component({
    selector: 'page-missions-postulate',
    templateUrl: 'missions-postulate.html'
})
export class MissionsPostulatePage {
    mission: any;
    segment: any;
    user: any;

    postulateData: any;
    postulateForm : FormGroup;

    requirementsData: any;
    requirementsForm : FormGroup;

    parametersData: any;

    submitAttempt: boolean = false;
    steps:any = 2;
    step:any = 1;

    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;

    constructor(
        public missionsData: MissionsData,
        public navParams: NavParams,
        public userData: UserData,
        public viewCtrl: ViewController,
        public formBuilder: FormBuilder,
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public uiData: UiData,
    ) {
        this.postulateForm = this.formBuilder.group({
            civility: [null, Validators.required],
            nom: ['', [Validators.required,Validators.minLength(2)]],
            prenom: ['', [Validators.required,Validators.minLength(2)]],
            birthday: ['', [Validators.required]],
            phone: ['', [Validators.required, Validators.pattern(/^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$/)]],
            /*secu: [null, [Validators.required, this.secuValidator.bind(this) ]],*/
        });
    }
    secuValidator(control: FormControl): {[s: string]: boolean} {
        if (control.value && control.value.length < 15) {
            return {invalidSecu: true};
        }
        if (control.value && control.value.length > 15) {
            return {invalidSecu: true};
        }
    }
    ionViewDidLoad() {
        var that = this;
        this.segment = "step1";
        this.step = 1;

        this.postulateData = {
            civility : 'mr',
            nom : '',
            prenom : '',
            birthday : '',
            phone : '',
           // secu : '',
        };
        that.missionsData.getMission(that.navParams.data.missionId).subscribe((data: any) => {
            that.mission = data;
            if(
                this.mission.requirements && (
                    (this.mission.requirements.diplomas && this.mission.requirements.diplomas.length>0) ||
                    (this.mission.requirements.certificates && this.mission.requirements.certificates.length>0) ||
                    (this.mission.requirements.languages && this.mission.requirements.languages.length>0) ||
                    (this.mission.requirements.experiences && this.mission.requirements.experiences.length>0) ||
                    (this.mission.userParameters)
                )
            )
            {
                this.steps=3;

                this.requirementsData = this.mission.requirements;
                if(!this.requirementsData)this.requirementsData={};
                this.userData.fullfillMissionRequirementForm(this.requirementsData);

                this.parametersData =  false;
                //if(!this.parametersData)this.parametersData={};
                //this.userData.fullfillMissionRequirementForm(this.requirementsData);

                var requirementsConfig = {};
                if(this.mission.userParameters) {
                    var existingUserParameters = this.userData.get('parameters');
                    this.parametersData = [];
                    var uiParameters = this.uiData.parametersList();
                    console.log(uiParameters);
                    for (let i = 0; i < Object.keys(this.mission.userParameters).length; i++) {
                        var oKey = Object.keys(this.mission.userParameters)[i];
                        var oVal = Object.assign({}, this.mission.userParameters[oKey]);

                        oVal.label = uiParameters[oKey].question;
                        oVal.options = uiParameters[oKey].options;
                        oVal.default = uiParameters[oKey].default;
                        if(existingUserParameters && existingUserParameters[oKey])
                            oVal.value = existingUserParameters[oKey].value;
                        else
                            oVal.value = oVal.default;
                        oVal.key = oKey;
                        oVal.isVisible = function(){ return true; };
                        if(oKey == 'shoes_size')
                            oVal.isVisible = function(parameters){
                                for(var ip=0;ip<parameters.length;ip++)
                                {
                                    if(parameters[ip].key == 'secured_shoes' && parameters[ip].value==1)return false;
                                }
                                return true;
                            };
                        this.parametersData.push(oVal);
                        //this.userData.fullfillMissionRequirementForm(this.requirementsData);
                        if(oVal.type=="bool" && oVal.required)
                            requirementsConfig[oKey]= [null, Validators.requiredTrue] ;
                        else if (oVal.required)
                            requirementsConfig[oKey]= [null, Validators.required] ;
                        else
                            requirementsConfig[oKey]= [null] ;
                    }
                    console.log(this.parametersData);
                }
                if(this.requirementsData.diplomas)
                    for(let i=0;i<this.requirementsData.diplomas.length;i++)
                    {
                        if(this.requirementsData.diplomas[i].required)
                            requirementsConfig['diploma'+i]= [null, Validators.requiredTrue] ;
                        else
                            requirementsConfig['diploma'+i]= [null] ;
                    }
                if(this.requirementsData.certificates)
                    for(let i=0;i<this.requirementsData.certificates.length;i++)
                    {
                        if(this.requirementsData.certificates[i].required)
                            requirementsConfig['certificate'+i]= [null, Validators.requiredTrue] ;
                        else
                            requirementsConfig['certificate'+i]= [null] ;
                    }
                if(this.requirementsData.experiences)
                    for(let i=0;i<this.requirementsData.experiences.length;i++)
                    {
                        if(this.requirementsData.experiences[i].required)
                            requirementsConfig['experience'+i]= [null, Validators.requiredTrue] ;
                        else
                            requirementsConfig['experience'+i]= [null] ;
                    }
                if(this.requirementsData.languages)
                    for(let i=0;i<this.requirementsData.languages.length;i++)
                    {
                        if(this.requirementsData.languages[i].required)
                            requirementsConfig['language'+i]= [null, Validators.requiredTrue] ;
                        else
                            requirementsConfig['language'+i]= [null] ;
                    }

                this.requirementsForm = this.formBuilder.group(requirementsConfig);
            }
        });
        /*
        this.missionsData.load('all').subscribe((data: any) => {
            for(let i=0;i<data.length;i++){
                if(data[i].id === this.navParams.data.missionId)
                {
                    this.mission = data[i];

                    break;
                }
            }
        });*/
        this.userData.load().subscribe(data => {
            that.user = data;
            if(that.user.civility)
            {
                if(that.user.civility.nom)    this.postulateData.nom = that.user.civility.nom;
                if(that.user.civility.prenom)    this.postulateData.prenom = that.user.civility.prenom;
                if(that.user.civility.birthday)    this.postulateData.birthday = that.user.civility.birthday;
                if(that.user.civility.phone)    this.postulateData.phone = that.user.civility.phone;
            }
            if(that.user.identity)
            {
                if(that.user.identity.secu)    this.postulateData.secu = that.user.identity.secu;
            }

            that.formationsRef = that.userData.getUserDbListReference('formations');
            that.experiencesRef = that.userData.getUserDbListReference('experiences');
            that.certificatesRef = that.userData.getUserDbListReference('certificates');
            that.languagesRef = that.userData.getUserDbListReference('languages');


            if(
                that.postulateData.nom && that.postulateData.nom!="" &&
                that.postulateData.prenom && that.postulateData.prenom!="" &&
                that.postulateData.birthday && that.postulateData.birthday!="" &&
                that.postulateData.phone && that.postulateData.phone!=""

            )
            {
                if(!this.requirementsForm || this.requirementsForm.valid)
                {
                    if(!this.requirementsForm)
                    {
                        this.segment = "step3";
                        this.step = 3;
                    }
                    else
                    {
                        if(this.step<3) {
                            var go3 = true;
                            for (let y = 0; y < Object.keys(this.requirementsData).length; y++) {
                                let k = Object.keys(this.requirementsData)[y];
                                let register = this.requirementsData[k];
                                for (let yy = 0; yy < Object.keys(register).length; yy++) {
                                    let requ = register[yy];
                                    if (!requ.validated) {
                                        go3 = false;
                                    }
                                }
                            }
                            if (go3) {
                                this.segment = "step3";
                                this.step = 3;
                            }
                            else {
                                this.segment = "step2";
                                this.step = 2;
                            }
                        }
                    }
                }
                else
                {
                    if(this.steps == 2) // no missions requirements
                    {
                        this.segment = "step3";
                        this.step = 3;
                    }
                    else
                    {
                        this.segment = "step2";
                        this.step = 2;
                    }
                }
            }

        });
    }
    savePostulate() {

        this.submitAttempt=true;
        var that = this;

        if(this.postulateForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            that.userData.update('civility','nom',that.postulateData.nom);
                            that.userData.update('civility','prenom',that.postulateData.prenom);
                            that.userData.update('civility','birthday',that.postulateData.birthday);
                            that.userData.update('civility','phone',that.postulateData.phone);
                            //that.userData.update('identity','secu',that.postulateData.secu);
                            this.submitAttempt = false;
                            if(this.steps == 2) // no missions requirements
                            {
                                this.segment = "step3";
                                this.step = 3;
                            }
                            else
                            {
                                this.segment = "step2";
                                this.step = 2;
                            }
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {
            console.log(this.postulateForm.value);
        }

    }
    saveRequirements(){
        this.submitAttempt=true;
        var that = this;

        if(this.requirementsForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            this.segment = "step3";
                            this.step = 3;
                            if(this.parametersData)
                            {
                                for(var ff=0;ff<this.parametersData.length;ff++)
                                {
                                    that.userData.update('parameters',this.parametersData[ff].key,{
                                        'key':this.parametersData[ff].key,
                                        'value':this.parametersData[ff].value
                                    });
                                }
                            }

                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {
            let prompt = this.alertCtrl.create({
                title: 'Informations manquantes',
                message: "Pour postuler à cette mission, vous devez remplir un certain nombre de conditions.<br/><br/>"+
                        "Cochez les éléments 1 à 1 pour poursuivre.<br/><br/>"+
                        "Ces informations seront stockées dans votre CV."
                ,
                buttons: [

                    {
                        text: 'J\'ai compris',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
    }
    postulateConfirmation(){
        var that = this;
        this.userData.set('missionCandidates/'+this.mission.id,{
            'mission':this.mission,
            'date': Date.now(),
            'status': 'submitted',
        });
        const toast = this.toastCtrl.create({
            message: 'Votre candidature a été enregistrée.',
            duration: 5000
        });
        this.dismiss(true);
        toast.present();

        let prompt = this.alertCtrl.create({
            title: 'Ajouter une présentation vidéo',
            message: "Pour maximiser vos chances, vous pouvez enregistrer une présentation vidéo.<br/><br/>"+
            "Souhaitez vous le faire maintenant ?<br/>"
            ,
            buttons: [

                {
                    text: 'Oui',
                    handler: data => {
                        that.recordVideo(that.mission);
                    }
                },
                {
                    text: 'Plus tard',
                    handler: data => {

                    }
                }
            ]
        });
        prompt.present();

    }
    recordVideo(missionData: any) {
        let videoRecordModal = this.modalCtrl.create(VideoWizardForm, { mission: missionData });
        videoRecordModal.onDidDismiss(data => {
            if(data)
            {
                //console.log(data);
            }
            else
            {

            }
        });
        videoRecordModal.present();
    }
    updateRequirementValidation(mode,requirement)
    {


        if(mode=="diploma" && requirement.validated ) {
            this.addFormationModal(requirement);
        }
        if(mode=="certificate" && requirement.validated ){
            this.addCertificateModal(requirement);
        }
        if(mode=="experience" && requirement.validated ){
            this.addExperienceModal(requirement);
        }
        if(mode=="language" && requirement.validated ){
            this.addLanguageModal(requirement);
        }

    }
    /****
     * Add or update Formation
     * Use Modal controller with parameters
     ****/
    addFormationModal(requirement) {
        var modalOptions = {
            mode: "formations",
            ref:this.formationsRef,
            object: null,
            level:requirement.title,
            introduction: "Pour cette mission, merci de valider cette formation de niveau "+requirement.title+" en précisant la date."
        };
        if(requirement.title){
            modalOptions['title'] = requirement.theme_title;
        }
        let profileModal = this.modalCtrl.create(CvAddForm, modalOptions);
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.userData.fullfillMissionRequirementForm(this.requirementsData);
            }
            else
            {
                requirement.validated = false;
            }
        });
        profileModal.present();
    }

    /****
     * Add or update Experience
     * Use Modal controller with parameters
     ****/
    addExperienceModal(requirement) {
        let profileModal = this.modalCtrl.create(CvAddForm, {
            mode: "experiences",
            ref:this.experiencesRef,
            object: null,
            job:requirement.jobs[0],
            duree:requirement.length,
            introduction: "Pour cette mission, merci de valider cette expérience de "+requirement.jobs[0]+" en précisant la date et la durée."
        });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.userData.fullfillMissionRequirementForm(this.requirementsData);
            }
            else
            {
                requirement.validated = false;
            }
        });
        profileModal.present();
    }

    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addCertificateModal(requirement) {
        let profileModal = this.modalCtrl.create(CvAddForm, {
            mode: "certificates",
            ref:this.certificatesRef,
            object: null,
            type: requirement.type,
            certificate: requirement.id,
            job: ((requirement.job)?requirement.job:null),
            introduction: "Validez cette compétence en précisant la date d'obtention du certificat ou du permis."
        });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.userData.fullfillMissionRequirementForm(this.requirementsData);
            }
            else
            {
                requirement.validated = false;
            }
        });
        profileModal.present();
    }

    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addLanguageModal(requirement) {
        let profileModal = this.modalCtrl.create(CvAddForm, {
            mode: "languages",
            ref:this.languagesRef,
            object: null,
            langue: requirement.language,
            level: requirement.level,
            introduction: "Pour cette mission, merci de valider vos compétences en de "+requirement.langue+" en précisant votre niveau."
        });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.userData.fullfillMissionRequirementForm(this.requirementsData);
            }
            else
            {
                requirement.validated = false;
            }
        });
        profileModal.present();
    }

    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss(data);
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-postulate/missions-postulate.ts